// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","navbar":"Footer_navbar__rGp6i","footer_bottom":"Footer_footer_bottom__RuzVv","footer_top":"Footer_footer_top__uqQKO","icon":"Footer_icon__Zscac"};